import React from "react";

import AccessController from "_shared/AccessController";
import { DashGridL2 } from "layouts/dash-grid";
import TopBar from "_shared/Top";
import { Box, Button, Grid, Typography } from "@mui/material";
import authAxios from "setups/axios";
import { toastMessage } from "utils/toastMessage";
import { Toaster } from "react-hot-toast";
import SyncIcon from "@mui/icons-material/Sync";
import { PageHeader, SectionCard } from "_shared/ui";

const Main = () => {
  const handleSync = async (e, value) => {
    // let url = `/api/v1/sync/all`;

    // // switch (value) {
    // //   case "user":
    // //     url = `/api/v1/sync/users`;
    // //     break;
    // //   case "dealer":
    // //     url = `/api/v1/sync/dealers`;
    // //     break;
    // //   case "ro":
    // //     url = `/api/v1/sync/ro`;
    // //     break;
    // //   case "taluka":
    // //     url = `/api/v1/sync/taluka`;
    // //     break;
    // //   case "state":
    // //     url = `/api/v1/sync/state`;
    // //     break;
    // //   case "territories":
    // //     url = `/api/v1/sync/territories`;
    // //     break;
    // //   default:
    // //     break;
    // // }

    // await authAxios()({
    //   url,
    //   method: "GET",
    // })
    //   .then((response) => {
    //     toastMessage(response?.data?.message, "success");
    //   })
    //   .catch((err) => {
    //     console.log("error", err);
    //   });
    
  };

  return (
    <>
      <PageHeader
        title="Sync"
        subtitle="Synchronize master data from the SAP APIs"
      />
      <Grid container spacing={2}>
        <Grid item xs={12} md={8} lg={6}>
          <SectionCard title="Sync SAP APIs">
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              Pull the latest master data from SAP into the dashboard. This may
              take a few moments to complete.
            </Typography>
            <Box>
              <Button
                variant="contained"
                onClick={(e) => handleSync(e)}
                endIcon={<SyncIcon />}
              >
                Sync
              </Button>
            </Box>
          </SectionCard>
        </Grid>
      </Grid>
    </>
  );
};

const Sync = () => {
  return (
    <AccessController roles={["AO", "RO", "ZO", "ADMIN"]}>
      <DashGridL2 Top={TopBar} Main={Main} />
      <Toaster />
    </AccessController>
  );
};

export default Sync;
